<main id="main">

    <kokos-header [page]="PagesEnum.SendMail" [title]="'sendmail.form.title' | i18next"></kokos-header>

    <div class="container-fluid ba-mailbox">

        @if (errorType !== null) {
            <div>
                <kokos-errorbox
                        [scrollIntoView]="errorType"
                        [errorType]="errorType"
                        [errorCode]="errorCode">
                </kokos-errorbox>
            </div>
        }

        @if (form) {
            <form [formGroup]="form">

                <p class="ba-required-hint">{{ 'sendmail.fill-marked-fields' | i18next }}</p>

                <pf-section name="nachricht"
                            [title]="('sendmail.form.message-to' | i18next) + ' <br/>' + nachrichtPayload.empfaengerName">

                    <div class="row ba-form-row">
                        @if (!isZuwanderungsinteressierter()) {
                        <div class="col-12">
                            <pf-field-display [label]="'sendmail.form.concern' | i18next"
                                              [display]="anliegenName"></pf-field-display>
                        </div>
                        }
                        @if (showSubanliegen) {
                            <div class="col-12">
                                <pf-field-display [label]="'sendmail.form.concern-type' | i18next"
                                                  [display]="subanliegenName"></pf-field-display>
                            </div>
                        }
                        <div class="col-12">
                            @if (betreffEditable) {
                                <pf-input name="betreff"
                                [label]="'sendmail.form.subject' | i18next"
                                controlName="betreff"
                                [validate]="validationEnabled"
                                [validationMessages]="validationMessages"/>
                            } @else {
                                <pf-field-display [label]="'sendmail.form.subject' | i18next"
                                                  [display]="nachrichtPayload.betreff"></pf-field-display>
                            }
                        </div>
                        <div class="col-12">
                            <pf-textarea name="text" [label]="'sendmail.form.body' | i18next" controlName="text"
                                         [validate]="validationEnabled" [validationMessages]="validationMessages"
                                         [maxLetters]="5000"/>
                        </div>

                    </div>

                    <kokos-nachricht-verlauf [nachrichtHistorie]="nachrichtHistorie" />

                </pf-section>

                @if (showUpload) {
                    <pf-section name="dateien" [title]="'sendmail.form.attachments' | i18next">
                        <kokos-nachricht-file-uploader name="uploadFile"
                                                       [anhaengeFormArray]="anhaengeFormArray"
                                                       [nachrichtId]="nachrichtPayload.entwurfId"
                                                       (requestCreateEntwurf)="onCreateEntwurf()"
                                                       (uploading)="processing=true"
                                                       (allFilesUploaded)="processing=false" />
                    </pf-section>
                }

                @if (isStepUser() || isZuwanderungsinteressierter()) {
                    <kokos-datenschutz></kokos-datenschutz>
                } @else if (isKindergeldFall() && anliegenName === KinderLeistung.KINDERGELD) {
                    <kokos-kenntnisnahme [type]="KinderLeistung.KINDERGELD"
                                         [validationMessages]="[{ key: 'required',message: 'sendmail.form.validation.required-checkbox' | i18next}]"
                                         [validate]="validationEnabled" />
                } @else if (isKindergeldFall() && anliegenName === KinderLeistung.KINDERZUSCHLAG) {
                    <kokos-kenntnisnahme [type]="KinderLeistung.KINDERZUSCHLAG"
                                         [validationMessages]="[{ key: 'required',message: 'sendmail.form.validation.required-checkbox' | i18next}]"
                                         [validate]="validationEnabled" />
                }

            </form>
        }
        <pf-footer [forwardButton]="forwardButton" [storeButton]="storeButton" [backButton]="backButton"
                   (forwardButtonClicked)="handleForwardClicked()" (storeButtonClicked)="handleStoreClicked()"
                   (backButtonClicked)="openCancelModal()"></pf-footer>
    </div>

</main>

<pf-modal
    #cancelModal
    name="cancel"
    [title]="('dialog.cancel.title' | i18next)"
    [body]="('dialog.cancel.text' | i18next)"
    modalId='modal-nachricht-cancel'
    [confirmButtonText]="('dialog.cancel.confirm' | i18next)"
    [cancelButtonText]="('dialog.cancel.cancel' | i18next)"
    (confirmed)="onConfirmCancelNachricht()"
/>